import { IItemCommon } from "models/base/Generics";
import { IRating, IResultFacets } from "../screens/AccountMembership/_private/types/midView";
import {
  DynamicRangeAttributeQueryString,
  SelectableCPsQueryString,
} from "contexts/RoutesObjectContext";
import { IAllCPsMap, ICpOption } from "models/Assets/IDynamicAttributes";
import { ICityLiteAsset } from "models/Assets/ICityAsset";
import {INeighborhoodAsset, INeighborhoodLiteAsset} from "models/Assets/INeighborhoodAsset";
import { ICategoryLiteAsset } from "models/Assets/ICategoryAsset";
import { IFilterFlag } from "contexts/ListingContextHelpers/interfaces";
import { TypeRouterApiBasePath } from "models/ILiteRouterApiResponse";
import { EnumOrderMode } from "../enums/EnumOrderMode";
import { EnumSort } from "../enums/EnumSort";
import { IPostCardJobPoster, IPostCardJobSeeker } from "models/IPostCard";
import { Links } from "models/sales";

export type TypeLoanType =
  | "OpenSooq"
  | "SoharBank"
  | "EtihadBank"
  | "EtihadBankRE";

export interface IPostSearchParams {
  cityId?: string; //1,2,3
  neighborhood_id?: string; // for the api
  dynamicAttributes?:
    | SelectableCPsQueryString
    | DynamicRangeAttributeQueryString;
  page?: number;
  perPage?: number;
  term?: string;
  memberId?: number;
  userName?: string;
  categoryId?: number;
  categoriesId?: string; //comma separated string
  subCategoryId?: number;
  orderMode?: EnumOrderMode;
  sort?: EnumSort;
  lat?: string;
  lng?: string;
  priceFrom?: any;
  priceTo?: any;
  price_currency?: number;
  search_type?: "id" | "phone";
  ignoreIds?: string;
  withImages?: boolean;
  "per-page"?: number;
}

export interface IFindPageQueryString {
  page?: number;
  term?: string;
  allCPsMap?: IAllCPsMap;
  have_images?: any;
  filterFlags?: any;
  basePath?: TypeRouterApiBasePath;
  dlpSlug?: string;
  withResultTags?: boolean;
  PostSearch: IPostSearchParams;
  "landing-popup"?: "1";
  similarSerp?:string;
  recommendedSerp?:string;
  includeSelf?:string;
}

export type TypeHomeScreenSections =
  | "continueBrowsing"
  | "latestAds"
  | "recentlyViews";

export type TypeSectionsQS = {
  [key in TypeHomeScreenSections]?: IPostSearchParams;
};
export type TypeNoviceADS = {
  [key in TypeHomeScreenSections]?: IPostsApiResponse;
};

export interface IHomeScreenQueryString extends TypeSectionsQS {
  sections: TypeHomeScreenSections;
}

export type TypeFacetGroup = {
  customSubCategories?: IItemCommon[];
  categories?: ICategoryLiteAsset[];
  subcategories?: IItemCommon[] | ICategoryLiteAsset[];
  neighborhoods?: INeighborhoodLiteAsset[];
  cities?: ICityLiteAsset[];
  dynamicParams?: {
    [key: string]: {
      is_indexable: boolean;
      is_linkable: number;
      items: IItemCommon[];
    };
  };
};

export interface IMetaPagination {
  totalCount: number;
  pageCount: number;
  currentPage: number;
  perPage: number;
  newAdCount?: number;
}

export interface IRelatedLinks {
  url_name: string;
  title: string;
  full_url: string;
}

export interface ICityLink {
  countries_id: number;
  full_url: string;
  id: number;
  lat: number;
  lng: number;
  name: string;
  name_english: string;
  order: number;
  region_id: number;
  url_name_en: string;
}

export interface IMetaData extends IMetaPagination {
  resultFacet?: IResultFacets;
  title?:string;
  searchMd5: string;
  search_id?: string;
  topKeywordSearches: [{ title: string; url_name: string }]; //tags
  facets?: IFacets[] | []; //used on SHop listing screen
  extraLinks: [
    {
      // most popular
      title: string;
      items: [{ label: string; href: string }];
    }
  ];
  pageTitle: string;
  pwaFacet: TypeFacetGroup;
  relatedLinks?: IRelatedLinks[] | [];
  filter_options?: IFilterFlag[];
  cities?: ICityLink[];
  FQA?: {
    __model1__: [];
    __model2__: [];
    __model3__: [];
    monthly_installment_number: number;
    shops_number: number;
    premium_ad_number: number;
  };
  showLoginPopUp?: boolean;
  anonymousBrowsing?: boolean;
  showLoginWidget?: boolean;
}

export interface IFacets {
  count: number;
  id: number;
  label: string;
  name: string;
  name_en: string;
  tag: string;
  url_name_ar: string;
  url_name_en: string;
  app_image_path?: string;
  icon?: string;
}

type IViewType = 'noImage' | 'list' | 'image' | 'grid'
export interface IPostsApiResponse {
  items: IPostData[];
  model?: {
    pageH2?: string;
    id?: number;
    name?: string;
    description?: string;
  };
  template?:IViewType;
  _meta: IMetaData;
  _links?: Links;
  searchTags?:ISearchTags
}

export interface ISearchTags {
  search:       Search[];
  label:        string;
  enable_clear: boolean;
  type:         string;
  field_id:     number;
  member_isShop?:boolean
}

export interface Search {
  key:   string;
  value: string;
}


export interface IPostsByTagsApiResponse extends IPostsApiResponse {
  model: {
    category_id: number;
    id: number;
    tag: string;
    keyword: string;
    lang: string;
    page_description: string;
  };
  seo: any;
}

export interface IArchivedPostResponse {
  id: string;
  name: string;
  message: string;
  code: number;
  status: 200 | 201;
  show_related_posts: boolean;
  post: {
    id: number;
    title: string;
    post_url: string;
    description: string;
    first_image_uri: string;
  };
  isMemberReported?: boolean;
}

export interface IGtmAttributes {
  CP1: string;
  CP2: string;
  CP3: string;
  CP4: string;
  Category: string;
  City: string;
  Neighbourhood: string;
  SubCategory: string;
}

export interface IPostData {
  vin_number?: {
    "vin_number"?: string;
    "ask_vin_number"?:boolean;
  };
  isMemberReported?: boolean;
  isQuickPost: boolean;
  isFullLoaded: boolean;
  id: number;
  member_id?: number;
  members_id?: number;
  cities_id: number;
  price: number;
  display_name: string;
  new_cat_id: number;
  subcategory_reporting_name?: string;
  category_reporting_name?: string;
  hide_user_contact_details: number;
  natural_date: string;
  lang?: string;
  neighborhood_name: string;
  title: string;
  local_phone: string;
  phone: string;
  masked_local_phone: string;
  record_posted_date_timestamp: number;
  record_expiration_date_timestamp: number;
  record_insert_date: number;
  post_url: string;
  firstImage?: IMediasWith360;
  neighborhood_id: number;
  first_image_uri: string;
  first_image_thumb?: string;
  services: string[];
  with_360: number;
  currency: string;
  bookmarkStatus: boolean;
  imagesCount: number;
  with_video?: number;
  with_youtube?: number;
  images: IPostImage[];
  category_id?: number;
  chat_enabled: number;
  postUrl: string;
  unit?: IUnit;
  city?: ICity;
  custom_param_string: string;
  note: null;
  dynamicAttributesObject: IDynamicAttributesObject[];
  price_list: IPriceList;
  starAttributes: IDynamicAttributesObject[];
  mediasWith360: IMediasWith360[];
  custom_param_array?: string[];
  neighborhood: INeighborhoodAsset;
  authorisedSeller?: boolean;
  is_owner_followed: boolean;
  rating: IRating;
  descriptionWithTags: string;
  is_owner_following: boolean;
  postMap: {
    lat: number;
    lng: number;
  };
  postUserActions: IPostUserActions;
  nextPrev: INextPrev;
  city_name: string;
  city_url: string;
  subcategory_name: string;
  extraLinksForSeo: {
    title: string;
    items: [
      {
        href: string;
        label: string;
      }
    ];
  };
  postDetails:any;
  pageTitle: string;
  postTags: IPostTags[];
  view_type?: "JobSeeker" | "JobPoster" | "default";
  card: IPostCardJobPoster | IPostCardJobSeeker;
  cv_id: string;
  geo_lng: string;
  geo_lat: string;
  loanType?: TypeLoanType;
  is_verified?:boolean;
  is_authorized_member?:boolean;
  is_delivery_service?: boolean;
  metaDescription?: string;
  share_deeplink?: string;
  rera_link?:string
  similarStringCps ? :string,
  askSellerQuestions?: any,
  branding: {
    avatar: string;
    name: string;
  }
  searchMember ? : ISearchMember,
  member_isShop?:boolean;
  contactAddon?:IContactAddon
  recommended_enabled?:boolean;
  similar_enabled?:boolean;
  similar_type:"infinite" | "normal";
}
export interface ISearchMember {
  id:              number;
  M_user_name:     string;
  full_name:       string;
  profile_picture: string;
  member_type:     number;
}

interface ICity {
  countries_id: number;
  id: number;
  lat: number;
  lng: number;
  name: string;
  name_english: string;
  order: number;
  region_id: number;
  url_name_en: string;
}

export interface IPostUserActions {
  priceDrop: number;
  askForImg: number;
  askForPrice: number;
  askForMap: number;
  askForVin?: number;
}

export interface IPriceList {
  id?: number;
  full_name: string;
  price: string | number;
  price_code: string;
  price_id: number;
  shorthand: string;
}

export interface INextPrev {
  prev_id?: string;
  prev_title?: string;
  prev_image?: string;
  prev_img_path?: string;
  prev_url?: string;
  next_id?: string;
  next_title?: string;
  next_image?: string;
  next_img_path?: string;
  next_url?: string;
  prev_short_title?: string;
  next_short_title?: string;
}

export interface IDynamicAttributesObject extends ICpOption {
  field_name: string;
  field_label: string;
  field_id: number;
  option_value: string | number;
  option_label: any;
  option_label_en: string;
  option_seo_value: string;
  option_seo_value_ar: string;
  option_seo_value_en: string;
  option_id: string;
  url_name: string;
  full_url: string;
  option_url: any;
  is_indexable?: boolean;
  field_data_type: string;
}

export interface IPostImage {
  id: number;
  image_uri: string;
  is_main: number;
  name: string;
  path: {
    large: string;
    medium: string;
    small: string;
  };
  posts_id: number;
}

export interface IPostTags {
  tag?: string;
  url?: string;
  url_name?: string;
  title?: string;
}

export interface IPostDetails {
  first_post?: null;
  first_featured: number;
  ribbon_for_urgent: boolean;
  highlight_for_urgent: boolean;
  is_donation: number;
  quality_score: number;
  has_paid_bumpup: number;
  turbo_type: number;
  is_vip: number;
  vipla_type: number;
  quality_score_report: string[];
  apply_json_ld: null;
  buy_now: number;
}

export interface ISearchMember {
  id: number;
  M_user_name: string;
  full_name: string;
  profile_picture: string;
  member_type: number;
}

export interface IMember {
  id: number;
  M_email: string;
  M_new_email: string;
  M_user_name: string;
  lang: string;
  isShop?: boolean;
  member_verification: number;
  is_followed: boolean,
  memberSocial: [];
  show_sms_verification_on_registration: boolean;
  membersDetails: {
    members_id: number;
    authorised_seller: boolean;
    show_shop_badge: number;
    buy_now: number;
    isREAgent: false;
  };
  hide_contact_info: number;
  gender: null;
  birthday: null;
  member_type: number;
  record_insert_date_timestamp: number;
  record_insert_date: string;
  first_name: string;
  last_name: string;
  full_name: string;
  profile_picture: string;
  profile_picture_large: string;
  phone_number: string;
  new_phone_number: string;
  responseTime: string;
  phone_country_code: string;
  chatToken: null;
  international_phone_number: string;
  memberCountry: string;
  paid_ads_count: number;
  isDefaultAvatar: boolean;
  dna: null;
  membership_type?:string;
  rating: IMemberRating;
  adsFree: boolean;
  is_pro_buyer: boolean;
  post_views_limit: number;
  recentSearchLimit: number;
  savedSearchLimit: number;
  memberLink: string;
  isBlocked: boolean;
  isNewUser: boolean;
  hasPassword: boolean;
  limitAccountReport:any;
  shopAvatar:string;
}

export interface IMemberRating {
  can_be_rated: boolean;
  can_rate_other: boolean;
  average_rating: number;
  n_rating: number;
  n_reviews: number;
  tags: ITag[];
  is_buyer_interact_with_seller: boolean;
  is_buyer_rate_seller: boolean;
  buyer_can_rate: boolean;
  buyer_to_seller_rate: number;
}

export interface IMembersDetails {
  members_id: number;
  authorised_seller: boolean;
  show_shop_badge: number;
  buy_now: number;
  isREAgent: boolean;
}

export interface ITag {
  count: string;
  formatCount: string;
  tag_id: number;
  label: string;
  label_ar: string;
  label_en: string;
  icon: string;
  iconUri: string;
  order: number;
}

export interface IPhoneNumberData {
  local_phone?: string;
  phone?: string;
}

export interface IUnit {
  plan?: null;
  payment_plan?: any[];
  lead_form_status?: number;
  developer?: IDeveloper;
}

export interface IDeveloper {
  project_id?: number;
  project_name?: string;
  project_logo?: string;
  developer_name?: string;
  developer_avatar?: string;
}

export interface IMediasWith360 {
  id?: number;
  post_id?: number;
  record_insert_date?: Date;
  record_update_date?: Date | null;
  weight?: number;
  status?: number;
  uri?: string;
  content_md5?: string;
  media_size?: number | null;
  original_size?: null;
  mime_type?: string;
  is_360?: number;
  thumbnail_uri?: null | string;
}

export type ITypeAskButton =
  "Ask_For_SHOP_Location"
  | "Ask_For_Location"
  | "Ask_For_Price"
  | "Ask_For_Images"
  | "Price_Drop"
  | "AskSeller"
  | "Ask_For_VIN"
  | "Map_Only";

export enum EnumJobsVertical {
  JOB_SEEKR="JobSeeker" ,
  JOB_POSTER="JobPoster"
}

export interface IContactAddon {
  sms:      SMS;
  whatsapp: SMS;
}

export interface SMS {
  enabled:      boolean;
  phone_number: string;
  message:      string;
}
